import { CacheableDataObject } from 'models/CacheableDataObject.jsx';
import { declickables } from '../components/Declickables';
import { Request } from '../components/Request';
import { LadderPopup } from '../components/LadderPopup';

export class Flair extends CacheableDataObject {

	beforeConstruct() {
		this.isNull = false;
		this.players = [];
		this.emote_name = null;
	}

	get fullUrl() {
		if(this.isNull) {
			return undefined;
		}
		return this.url;
	}

	createElement() {
		let img = $('<img>');
		let flairClass = 'flair-' + this.name;
		img = img.addClass('flairy').addClass(flairClass).attr('src', this.fullUrl);
		return img;
	}
}

Flair.prototype.dataLocationParsers = {
	players: (flair, data) => {
		flair.players = [];
		_.each(data.players, (player) => {
			flair.players.push(Users.update(player));
		});
	},
};